/**
 * @file src/_modulos/financeiro/listagem/columns/components/observacao.tsx
 * @description Componente para exibir observações em badge com hovercard
 */

"use client";

import { IconFileText, IconX } from "@tabler/icons-react";
import { Badge, HoverCard, HoverCardContent, HoverCardTrigger } from "visuais";

interface ObservacaoBadgeProps {
  observacao?: string | null;
}

export function ObservacaoBadge({ observacao }: ObservacaoBadgeProps) {
  if (!observacao || observacao.trim() === "") {
    return (
      <Badge
        variant="outline"
        className="text-muted-foreground border-muted-foreground/20"
      >
        <IconX className="size-3 mr-1" />
        Sem observação
      </Badge>
    );
  }

  const isLong = observacao.length > 21;
  const displayText = isLong ? `${observacao.substring(0, 20)}...` : observacao;

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Badge
          variant="outline"
          className="text-blue-600 dark:text-blue-400 border-blue-600/20 dark:border-blue-400/20 cursor-help hover:bg-blue-50 dark:hover:bg-blue-950/20 transition-colors"
        >
          <IconFileText className="size-3 mr-1" />
          {displayText}
        </Badge>
      </HoverCardTrigger>
      <HoverCardContent className="w-80 text-sm">
        <div className="space-y-2">
          <h4 className="font-medium text-blue-600 dark:text-blue-400">
            Observação
          </h4>
          <p className="text-muted-foreground leading-relaxed">{observacao}</p>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
